import classnames from "classnames"
import { LEARN } from "path/constants"
import PathItemControls from "../PathItemControls"
import "./PathGroup.css"
import PathGroupCompletion from "./PathGroupCompletion"
import PathGroupDetails from "./PathGroupDetails"
import PathGroupSteps from "./PathGroupSteps"

const PathGroup = function (props) {
  const {
    item,
    mode,
    stats,
    isNext,
    expanded,
    analytics,
    nextStepURL,
    handleToggleExpand,
    dueDate,
    startsDate,
    isInactive
  } = props

  const className = classnames("PathGroup", {
    "PathGroup--inactive": isInactive
  })

  const stepCount = item.items.length

  return (
    <div className={className}>
      <PathGroupDetails
        group={item}
        stats={stats}
        expanded={expanded}
        analytics={analytics}
        isNext={isNext}
        isInactive={isInactive}
        startsDate={startsDate}
        onToggleExpand={handleToggleExpand}
      />
      {mode > LEARN && stepCount > 0 ? (
        <PathItemControls
          className="PathGroup__controls"
          inlineControls={
            expanded
              ? ["Notes", "Dates"]
              : ["Stats", "Review", "Notes", "Dates"]
          }
          buttonStyles={{ styleType: "secondary" }}
          item={item}
        />
      ) : undefined}
      <PathGroupSteps
        group={item}
        expanded={expanded}
        stepCount={stepCount}
        startsDate={startsDate}
      />
      <PathGroupCompletion
        mode={mode}
        group={item}
        stats={stats}
        isNext={isNext}
        startsDate={startsDate}
        dueDate={dueDate}
        isInactive={isInactive}
        nextStepURL={nextStepURL}
        expanded={expanded}
        onToggleExpand={handleToggleExpand}
        analytics={analytics}
      />
    </div>
  )
}

PathGroup.displayName = "PathGroup"

export default PathGroup
